import ResourceSvc from '@/services/resource.svc.js';
import swal from 'sweetalert2';
import { Input, Button, Select, Option, Popover } from 'element-ui'
import store from '@/services/store';
const svc = new ResourceSvc();
import { EventBus } from '@/services/Event.js';

export default {
    name: 'BasketDetailsTab',
    components: {
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        [Popover.name]: Popover,
        Button
    },
    computed: {
        loginUrl() {
            return process.env.url.oldAppLogin;
        },
    },
    data() {
        return {
            basketDetails: [],
            isAnyPaymentItem: false,
            isProcessing: true
        }
    },
    methods: {
        proceedToPayment() {
            this.$router.push({ path: "/membership/billing/4" });
        },
        loadData() {
            var self = this;
            window.scrollTo(0, 0);
            self.isProcessing = true;

            svc.getBasketDetails().then(response => {
                var allData = response.body;
                if (allData) {
                    if (!allData.isSuccess) {
                        self.isProcessing = false;
                        self.isAnyPaymentItem = false;
                        return;
                    }
                    else {
                        self.basketDetails = allData.outputData;
                        self.isAnyPaymentItem = true;
                    }
                }
                self.isProcessing = false;
            },
                () => {
                    self.$showError("Error occured!", self.exitUrl);
                });
        },
        deleteAllBasketDetails() {
            var self = this;
            window.scrollTo(0, 0);
            self.isProcessing = true;

            svc.deleteAllBasketDetails().then(response => {
                var allData = response.body;
                if (allData) {
                    if (!allData.isSuccess) {
                        self.$showError(allData.message);
                    } else {
                        self.loadData();
                        EventBus.$emit('update-basket');
                    }
                    self.isProcessing = false;
                }
            },
                () => {
                    self.$showError("Error occured!", self.exitUrl);
                });
        },
        deleteBasketItem(item) {
            let self = this;

            let message = `<ol class="list-group">${
                this.basketDetails.paymentItems.filter(ctm => {
                        return ctm.groupId == item.groupId;
                    }).map(x => {
                        return `<li class="list-group-item">
                                    <span class="expanded-items-label">${x.userDetails.fullName} (${x.userDetails.tiIdNumber})</span><br>
                                    <span class="expanded-items"> ${(x.membership ? x.membership.label
                                    : x.club ? x.club.name : x.clubJoinType ? x.clubJoinType.name : ''
                                + x.description ? x.description : '')}</span></li>`;
                }).join(' ')}</ol>`;

            swal({
                title: 'Are you sure you want to remove the item?',
                html: message,
                type: 'question',
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-default',
                cancelButtonClass: 'btn btn-danger',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(function (result) {
                if (result.value) {
                    window.scrollTo(0, 0);
                    self.isProcessing = true;

                    svc.deleteBasketItemByUserId(item.paidByUserId, item.groupId).then(response => {
                        var allData = response.body;
                        if (allData) {
                            if (!allData.isSuccess) {
                                self.$showError(allData.message);
                            } else {
                                self.loadData();
                                EventBus.$emit('update-basket');
                            }
                            self.isProcessing = false;
                        }
                    },
                        () => {
                            self.$showError("Error occured!", self.exitUrl);
                        });

                }
            });
        },
        saveData() {
            if (!this.isValidModel()) {
                this.$showError("Please fill required fields!");
                return;
            }
            window.scrollTo(0, 0);
            var self = this;
            var data = self.data;
            data.itemId = self.itemId;

            self.isProcessing = true;
            svc.createPaymentUrl(self.getController, data).then(response => {
                self.isProcessing = false;
                var allData = response.body;
                if (allData) {
                    if (!allData.isSuccess) {
                        if (allData.currentUserId == 0) {
                            self.$showError(allData.message);
                            self.login();
                            return;
                        }

                        self.showError(allData.message, allData.redirectUrl);
                        return;
                    }
                    else if (!allData.redirectUrl) {
                        window.location.href = self.thankYouUrl;
                    }
                    self.isProcessing = true;
                    self.showSuccessAndRedirectToSagePay(allData.redirectUrl);
                } else {
                    self.showError("Something went wrong!", self.exitUrl);
                }
            },
                () => {
                    self.showError("Something went wrong!", self.exitUrl);
                });
        },
        exit() {
            window.location.href = this.exitUrl;
        },
        back() {
            this.$router.push(-1);
        },
        login() {
            window.location.href = this.loginUrl;
        },
    },
    created() {
        this.loadData();
    },
    mounted() {
        var self = this;
        var user = store.getters.getCurrentUser;
        if (user && user.roles && user.roles.length) {
            if (user.roles.some(function (el) { return el === "Admin"; })) {
                self.$router.push({ path: "/" });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/basket/basket-page.js